import React, { useEffect, useState } from "react";
import DateSelect from "../utils/DateSelect";
import PointsSelect from "../utils/PointsSelect";
import MultiSelect from "../utils/MultiSelect";
import Loader from '../utils/Loader';
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { fetchUsersByRole } from "../../action/user";
import { roleId } from "../../constants/app";
import { fetchFilials } from "../../action/handbook";
import { fetchCategories, fetchGoods, fetchRawsList, fetchReportRevenue, setReportsFilters } from "../../action";
import ErrorContainer from "../utils/ErrorContainer";
import { fromStore } from "../../selectors";
import { fetchReceipes, getGoodWithReceipeData } from "../../action/recipes";
import { formatNumberWithSpaces, parseNumToFixed } from "../../utils/common";
import SortButton from "../utils/SortButton";
import { utils, writeFileXLSX } from 'xlsx';
import swal from 'sweetalert';
import moment from "moment";
import Select from 'react-select';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

function ResultRow ({item}) {
    return (
        <tr className='kt-datatable__row' style={{ backgroundColor: '#cfcfcf61'}}>
            <td className='kt-datatable__cell' style={{ width: '170px' }}>
                <span>ИТОГО</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '170px' }} />
            <td className='kt-datatable__cell' style={{ width: '100px' }}>
                <span>{item.count != null ? formatNumberWithSpaces(item.count) : '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '170px' }} />
            <td className='kt-datatable__cell' style={{ width: '140px' }}>
                <span>{item.sum != null ? formatNumberWithSpaces(item.sum) : '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '180px' }} />
            <td className='kt-datatable__cell' style={{ width: '170px' }} />
            <td className='kt-datatable__cell' style={{ width: '80px' }} />
            <td className='kt-datatable__cell' style={{ width: '160px' }} />
            <td className='kt-datatable__cell' style={{ width: '160px' }} />
        </tr>
    )
}

function ItemRow ({item}) {
    return (
        <tr className='kt-datatable__row'>
            <td className='kt-datatable__cell' style={{ width: '170px' }}>
                <span>{item.category || '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '170px' }}>
                <span>{item.name || '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '100px' }}>
                <span>{item.count != null ? formatNumberWithSpaces(item.count) : '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '170px' }}>
                <span>{item.averagePoint != null ? formatNumberWithSpaces(item.averagePoint) : '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '140px' }}>
                <span>{item.sum != null ? formatNumberWithSpaces(item.sum) : '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '180px' }}>
                <span>{formatNumberWithSpaces(item.averagePrice) || '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '170px' }}>
                <span>{item.averageCostprice != null ? formatNumberWithSpaces(item.averageCostprice) : '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '80px' }}>
                <span>{item.foodCost != null ? `${item.foodCost} %` : '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '160px' }}>
                <span>{item.contributionRevenue != null ? `${item.contributionRevenue} %` : '-'}</span>
            </td>
            <td className='kt-datatable__cell' style={{ width: '160px' }}>
                <span>{item.popular != null ? `${item.popular} %` : '-'}</span>
            </td>
        </tr>
    )
}

export default function SalesReport() {
    const data = useSelector(state => state.reports.salesReport);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);
    const goods = useSelector(state => state.good.list);
    const goodsLoading = useSelector(fromStore.loaderGoodsSelector);
    const receipes = useSelector(state => state.recipes.list);
    const raws = useSelector(fromStore.rawListSelector);
    const categories = useSelector(fromStore.categoryListSelector);

    const { result, filters, loading } = data;
    const [ regionalDirectors, setRegionalDirectors ] = useState([]);
    const [ _sort, setSort ] = useState({ field: 'category', sort: 'ASC'});
    const [ renderFilters, setRenderFilters ] = useState(filters);
    const [ tableData, setTableData ] = useState({ goods: [], total: {} });
    const [ selectedCategory, setSelectedCategory ] = useState();

    const dispatch = useDispatch();

    useEffect(() => {
        const getData = async () => {
            const regDirs = await dispatch(fetchUsersByRole({ role: roleId.regionalDirector }));
            const resultDirs = regDirs.map((dir) => ({ value: dir.id, label: dir.name ? dir.name : dir.username, points: dir.points })).sort((a, b) => a.label.localeCompare(b.label, 'ru'));
            setRegionalDirectors(resultDirs);
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
        };

        isEmpty(goods) && dispatch(fetchGoods());
        isEmpty(categories) && dispatch(fetchCategories())
        if (isEmpty(raws)) dispatch(fetchRawsList());
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [goods]);

    useEffect(() => {
        const getData = async () => {
            if (!result || !goods || !raws) return;
            const goodsData = await getRenderData();
            setTableData(goodsData);
        };
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result, goods, raws, receipes, renderFilters]);

    const handleClickSort = (newFiled) => {
        const { field, sort } = _sort;
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort({field: _sort.field, sort: newSort});
        } else {
            setSort({field: newFiled, sort: 'ASC'});
        }
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.created_at_gte = e.min;
            updated.created_at_lte = e.max;
            dispatch(setReportsFilters('salesReport', updated));
        }
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('salesReport', updated));
    }

    const onSearch = () => {
        dispatch(fetchReportRevenue({ withGoods: true }, 'salesReport'));
        setRenderFilters(filters);
        if (renderFilters.created_at_gte !== filters.created_at_gte || isEmpty(receipes)) dispatch(fetchReceipes({ _limit: -1, startDate_lte: filters.created_at_lte }));
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if ((!filters.points || filters.points.length === 0) && (!filters.regionalDirectors || filters.regionalDirectors.length === 0)) return true;
        return false;        
    }

    const getRenderData = async () => {
        if (isEmpty(goods)) return { goods: [], total: {} };

        const getCostPriceGood = (receipeData, field = 'default') => {
            if (isEmpty(receipeData)) return null;
            
            const sum = receipeData.reduce((acc, item) => {
                const rawData = raws.find((raw) => raw.id === item.id);
                if (!rawData) return acc;
                
                const price = parseNumToFixed(rawData.last_price);
                
                if (item.count) {
                    const quantity = item.count[field] ? parseNumToFixed(item.count[field], 3) : 0;
                    acc += price * quantity;
                } else {
                    const quantity = item.quantity && item.quantity[field] ? parseNumToFixed(item.quantity[field], 3) : 0;
                    acc += price * quantity;
                }
                
                return acc;
            }, 0);
            
            return parseNumToFixed(sum);
        }

        const entityGoods = await Promise.all(goods.map(async (good) => {
            const categoryTitle = (good.category && good.category.title) ? good.category.title : 'Не определена';
            const categoryId = good.category ? good.category.id ? good.category.id : good.category : null;
            const receipeData = await dispatch(getGoodWithReceipeData(good));
            
            if (!isEmpty(good.modifications)) {
                return good.modifications.map((mod) => {
                    const costprice = getCostPriceGood(receipeData, mod.default ? null : mod.id);
                    return {
                        id: good.id,
                        idMod: mod.default ? null : mod.id,
                        name: `${good.name || `Наименование товара id ${good.id} не определено`} ${mod.title || `Наименование модификации id ${mod.id} не определено`}`,
                        category: categoryTitle,
                        categoryId,
                        receipeData,
                        costprice
                    };
                });
            }
            const costprice = getCostPriceGood(receipeData);
            return [{ id: good.id, name: good.name || `Наименование товара id ${good.id} не определено`, category: categoryTitle, categoryId, receipeData, costprice }];
        }));
        
        const normalizedGoods = entityGoods.flat();

        const normalizedOrders = (result || []).map((order) => {
            if (order.goods && typeof order.goods === 'string') {
                return { ...order, goods: JSON.parse(order.goods)}
            } else {
                return order;
            }
        });
        
        const reduceWokComponents = (wokEntity, goodId, mainCount = 0) => {
            return Object.entries(wokEntity).reduce((acc, [id, itemData]) => {
                if (String(id) !== goodId) return acc;
                let price = 0;
                if (itemData.data && itemData.data.price) {
                    price = itemData.data.price;
                } else if (itemData.price) {
                    price = itemData.price;
                }

                const count = itemData.count ? itemData.count * mainCount : mainCount;
                acc.count += count
                acc.sum += parseNumToFixed(count * price);
                if (itemData.costpriceGood) acc.costpriceGood += itemData.costpriceGood;
                return acc;
            }, {sum: 0, count: 0, costpriceGood: null });
        }

        const goodWithOrderData = normalizedGoods.map((good) => {
            const orderData = normalizedOrders.reduce((acc, order) => {
                if (!order || isEmpty(order.goods)) return acc;
                const goodId = good.idMod ? `${good.id}_${good.idMod}` : String(good.id);
                const entityGoods = order.goods.filter((item) => String(item.id) === goodId);
                if (!isEmpty(entityGoods)) {
                    const dataOrderGoods = entityGoods.reduce((goodAcc, item) => {
                        goodAcc.count += item.count || 0;
                        let costpriceGood = 0;

                        if (item.costpriceGood) {
                            costpriceGood = item.costpriceGood;
                        } else {
                            costpriceGood = parseNumToFixed(good.costprice * item.count);
                        }

                        goodAcc.costpriceGood += costpriceGood;
                        goodAcc.sum += parseNumToFixed((item.count || 0) * (item.price || 0));
                        return goodAcc;
                    }, { sum: 0, count: 0, costpriceGood: 0});

                    acc.count += dataOrderGoods.count || 0;
                    acc.costpriceGood += dataOrderGoods.costpriceGood || 0;
                    acc.sum += dataOrderGoods.sum || 0;
                } else if (!good.idMod) {
                    const woksGoods = order.goods.filter((item) => item.isWok);
                    if (!woksGoods || woksGoods.length === 0) return acc;
                    const dataOrderGoods = woksGoods.reduce((goodAcc, item) => {
                        if (isEmpty(item.wokData)) return goodAcc;
                        const { main, meat, topping, souce } = item.wokData;
                        if (main && String(main.id) === goodId) {
                            goodAcc.count += item.count;
                            goodAcc.sum += parseNumToFixed((item.count || 0) * (main.price || 0));
                            if (main.costpriceGood) goodAcc.costpriceGood += main.costpriceGood;
                        }

                        if (!isEmpty(meat)) {
                            const meatData = reduceWokComponents(meat, goodId);
                            if (!isEmpty(meatData)) {
                                if (meatData.count) goodAcc.count += meatData.count;
                                if (meatData.sum) goodAcc.sum += meatData.sum;
                                if (meatData.costpriceGood) goodAcc.costpriceGood += meatData.costpriceGood;
                            }
                        }

                        if (!isEmpty(topping)) {
                            const toppingData = reduceWokComponents(topping, goodId);
                            if (!isEmpty(toppingData)) {
                                if (toppingData.count) goodAcc.count += toppingData.count;
                                if (toppingData.sum) goodAcc.sum += toppingData.sum;
                                if (toppingData.costpriceGood) goodAcc.costpriceGood += toppingData.costpriceGood;
                            }
                        }

                        if (!isEmpty(souce)) {
                            const souceData = reduceWokComponents(souce, goodId, item.count);
                            if (!isEmpty(souceData)) {
                                if (souceData.count) goodAcc.count += souceData.count;
                                if (souceData.sum) goodAcc.sum += souceData.sum;
                                if (souceData.costpriceGood) goodAcc.costpriceGood += souceData.costpriceGood;
                            }
                        }

                        return goodAcc;
                    }, { sum: 0, count: 0, costpriceGood: 0 });

                    acc.count += dataOrderGoods.count || 0;
                    acc.costpriceGood += dataOrderGoods.costpriceGood || 0;
                    acc.sum += dataOrderGoods.sum || 0;
                }

                return acc;
            }, { sum: 0, count: 0, costpriceGood: 0 });

            if (!isEmpty(orderData)) {
                let averageCostprice = good.costprice || null;
                if (orderData.costpriceGood && orderData.count) averageCostprice = parseNumToFixed(orderData.costpriceGood / orderData.count);
                return {
                    ...good,
                    sum: orderData.sum || 0,
                    count: orderData.count || 0,
                    costpriceGood: orderData.costpriceGood || 0,
                    averageCostprice
                }
            }
            return { ...good, averageCostprice: good.costprice};
        });

        const total = goodWithOrderData.reduce((acc, good) => {
            if (!good || (!good.count && !good.sum)) return acc;
            if (good.sum) acc.sum += good.sum;
            if (good.count) acc.count += good.count;
            return acc;
        }, { sum: 0, count: 0 });

        const resultGoods = goodWithOrderData.map((good) => {
            const entity = { ...good };
            if (entity.count) {
                if (entity.sum) entity.averagePrice = parseNumToFixed(entity.sum / entity.count);
                if (renderFilters.points && renderFilters.points.length > 0) {
                    entity.averagePoint = parseNumToFixed(entity.count / renderFilters.points.length);
                } else if (renderFilters.regionalDirectors && renderFilters.regionalDirectors.length > 0) {
                    let dirsPointsCount = 0;
                    renderFilters.regionalDirectors.forEach((dir) => {
                        if (dir && dir.points && dir.points.length > 0) dirsPointsCount += dir.points.length;
                    });
                    entity.averagePoint = parseNumToFixed(entity.count / dirsPointsCount);
                } else {
                    entity.averagePoint = parseNumToFixed(entity.count / pointsCount);
                }
                if (total.count) entity.popular = parseNumToFixed((entity.count / total.count) * 100);
            }
            if (entity.averageCostprice && entity.averagePrice) entity.foodCost = parseNumToFixed((entity.averageCostprice / entity.averagePrice) * 100);
            if (entity.sum && total.sum) entity.contributionRevenue = parseNumToFixed((entity.sum / total.sum) * 100);
            return entity;
        });
        return { goods: resultGoods, total };
    }

    const onExport = () => {
        const { goods, total } = tableData;
        const filteredGoods = selectedCategory && selectedCategory.value ? goods.filter((good) => good.categoryId === selectedCategory.value) : goods;
        const renderTotal = selectedCategory && selectedCategory.value ? filteredGoods.reduce((acc, good) => {
            if (!good || (!good.count && !good.sum)) return acc;
            if (good.sum) acc.sum += good.sum;
            if (good.count) acc.count += good.count;
            return acc;
        }, { sum: 0, count: 0 }) : total;

        if (isEmpty(filteredGoods)) return swal({
            title: "Нет данных для экспорта",
            icon: "error",
            button: "Ок",
        });

        const { field, sort } = _sort;
        const exportData = filteredGoods.sort((a, b) => {
            const aField = a[field || 'category'];
            const bField = b[field || 'category'];

            if (aField == null && bField != null) return 1;
            if (aField != null && bField == null) return -1;
            if (aField == null && bField == null) return 0;
        
            if (sort === 'DESC') {
                if (typeof aField === 'string') {
                    const aLower = aField.toLowerCase();
                    const bLower = bField.toLowerCase();
                    if (aLower > bLower) return -1;
                    if (aLower < bLower) return 1;
                    return 0;
                }
                return bField - aField;
            } else {
                if (typeof aField === 'string') {
                    const aLower = aField.toLowerCase();
                    const bLower = bField.toLowerCase();
                    if (aLower < bLower) return -1;
                    if (aLower > bLower) return 1;
                    return 0;
                }
                return aField - bField;
            }
        }).map((good) => {
            return {
                'Категория': good.category || '-',
                'Наименование': good.name || '-',
                'Кол-во': good.count != null ? good.count : '-',
                'Ср. кол-во на филиал': good.averagePoint != null ? good.averagePoint : '-',
                'Сумма': good.sum != null ? good.sum : '-',
                'Средняя отпускная цена': good.averagePrice != null ? good.averagePrice : '-',
                'Себестоимость (1 ед.)': good.averageCostprice != null ? good.averageCostprice : '-',
                'FC (%)': good.foodCost != null ? good.foodCost : '-',
                'Вклад в выручку (%)': good.contributionRevenue != null ? good.contributionRevenue : '-',
                'Аудитория (%)': good.popular != null ? good.popular : '-',
            }
        });

        exportData.unshift({
            'Категория': 'ИТОГО',
            'Наименование': '',
            'Кол-во': renderTotal.count != null ? renderTotal.count : '-',
            'Ср. кол-во на филиал': '',
            'Сумма': renderTotal.sum != null ? renderTotal.sum : '-',
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        const periodText = `${moment(renderFilters.created_at_gte).format('DD.MM.YYYY')} - ${moment(renderFilters.created_at_lte).format('DD.MM.YYYY')}`;
        utils.book_append_sheet(wb, ws, 'Сводный отчет по продажам');
        writeFileXLSX(wb, `Сводный отчет по продажам ${periodText}.xlsx`);
    }

    const renderData = () => {
        if ((!result || result.length === 0) && (!renderFilters.points || renderFilters.points.length === 0) && (!renderFilters.regionalDirectors || renderFilters.regionalDirectors.length === 0)) return false;
        return true;       
    }

    const onChangeCategory = (value) => {
        if (!value) setSelectedCategory(null);
        setSelectedCategory(value);
    }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Сводный отчет по продажам
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Период *</label>
                        <DateSelect
                        isDisabled={loading}
                        isLoading={loading}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                        }}
                        limit={{ 
                            field: 'months',
                            value: 6
                        }}
                        width={200}
                        onChange={onChangeDateSelect}
                        />
                    </div>
                    <div>
                        <label>Филиалы {(filters.regionalDirectors && filters.regionalDirectors.length > 0) ? '' : '*'}</label>
                        <PointsSelect width={200} placeholder='Филиалы' values={filters.points} setData={setFilters('points')} disabled={loading || (filters.regionalDirectors && filters.regionalDirectors.length > 0)}/>
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Категория</label>
                        <Select
                            isLoading={loading}
                            isDisabled={loading}
                            closeMenuOnSelect={true}
                            options={[
                                { value: null, label: 'Все категории'},
                                ...(categories || []).map((category) => ({ value: category.id, label: category.title }))
                            ]}
                            onChange={onChangeCategory}
                            placeholder="Категория"
                            noOptionsMessage={() => 'Нет категория'}
                            value={selectedCategory}                   
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Региональный директор {(filters.points && filters.points.length > 0) ? '' : '*'}</label>
                        <MultiSelect data={regionalDirectors} width={200} placeholder='Рег. директор' values={filters.regionalDirectors} setData={setFilters('regionalDirectors')} loading={loading} disabled={loading || (filters.points && filters.points.length > 0)}/>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                    </div>
                </div>
            </div>
        );
    }

    const renderTable = () => {
        const { field, sort } = _sort;
        const { goods, total } = tableData;
        const filteredGoods = selectedCategory && selectedCategory.value ? goods.filter((good) => good.categoryId === selectedCategory.value) : goods;
        const renderTotal = selectedCategory && selectedCategory.value ? filteredGoods.reduce((acc, good) => {
            if (!good || (!good.count && !good.sum)) return acc;
            if (good.sum) acc.sum += good.sum;
            if (good.count) acc.count += good.count;
            return acc;
        }, { sum: 0, count: 0 }) : total;

        return(
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded' style={{ overflowX: 'auto', maxWidth: '100%' }}>
                <table className='kt-datatable__table' style={{ minWidth: '1650px', width: 'auto' }}>
                    <thead className='kt-datatable__head'>
                        <tr className='kt-datatable__row'>
                            <th className='kt-datatable__cell' style={{ width: '170px' }}>
                                <SortButton
                                className={field === 'category' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Категория' onClick={() => handleClickSort('category')} 
                                up={field === 'category' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '170px' }}>
                                <SortButton
                                className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Наименование' onClick={() => handleClickSort('name')} 
                                up={field === 'name' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '100px' }}>
                                <SortButton
                                className={field === 'count' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Кол-во' onClick={() => handleClickSort('count')} 
                                up={field === 'count' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '170px' }}>
                                <SortButton
                                className={field === 'averagePoint' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Ср. кол-во на филиал' onClick={() => handleClickSort('averagePoint')} 
                                up={field === 'averagePoint' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton
                                className={field === 'sum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Сумма' onClick={() => handleClickSort('sum')} 
                                up={field === 'sum' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '180px' }}>
                                <SortButton
                                className={field === 'averagePrice' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Средняя отпускная цена' onClick={() => handleClickSort('averagePrice')} 
                                up={field === 'averagePrice' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '170px' }}>
                                <SortButton
                                className={field === 'averageCostprice' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Себестоимость (1 ед.)' onClick={() => handleClickSort('averageCostprice')} 
                                up={field === 'averageCostprice' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '80px' }}>
                                <SortButton
                                className={field === 'foodCost' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='FC (%)' onClick={() => handleClickSort('foodCost')} 
                                up={field === 'foodCost' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '160px' }}>
                                <SortButton
                                className={field === 'contributionRevenue' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Вклад в выручку (%)' onClick={() => handleClickSort('contributionRevenue')} 
                                up={field === 'contributionRevenue' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '160px' }}>
                                <SortButton
                                className={field === 'popular' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Аудитория (%)' onClick={() => handleClickSort('popular')} 
                                up={field === 'popular' && sort === 'ASC'}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody className='kt-datatable__body'>
                        <ResultRow item={renderTotal} />
                        {filteredGoods && filteredGoods.length > 0 && filteredGoods.sort((a, b) => {
                        const aField = a[field || 'category'];
                        const bField = b[field || 'category'];

                        if (aField == null && bField != null) return 1;
                        if (aField != null && bField == null) return -1;
                        if (aField == null && bField == null) return 0;
                    
                        if (sort === 'DESC') {
                            if (typeof aField === 'string') {
                                const aLower = aField.toLowerCase();
                                const bLower = bField.toLowerCase();
                                if (aLower > bLower) return -1;
                                if (aLower < bLower) return 1;
                                return 0;
                            }
                            return bField - aField;
                        } else {
                            if (typeof aField === 'string') {
                                const aLower = aField.toLowerCase();
                                const bLower = bField.toLowerCase();
                                if (aLower < bLower) return -1;
                                if (aLower > bLower) return 1;
                                return 0;
                            }
                            return aField - bField;
                        }
                    }).map((item, index) => <ItemRow key={index} item={item} />)}
                    </tbody>
                </table>
            </div>
        );
    }

    const renderBody = () => {
        if (loading || pointLoading || goodsLoading) return <div style={styles.loading}><Loader /></div>;        

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="salesReport" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}
            </div>
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}